
import { yupResolver } from "@hookform/resolvers/yup";
import PillButton from "components/button/Pills";
import Input from "components/Input";
import { showToast } from "components/Toaster";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import httpClient from "services/network/httpClient";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import * as yup from "yup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBuilding,
  faEnvelope,
  faMapMarkerAlt,
  faUser
} from "@fortawesome/free-solid-svg-icons";

const schema = yup.object().shape({
  distributorName: yup.string().required("Distributor name is required"),
  customerCode: yup.string().required("Distributor name is required"),
  email: yup.string().email("Enter a valid email").required("Email is required"),
  contactPerson: yup.string().required("Contact person is required"),
  address: yup.string().required("Address is required"),
  countryCode: yup.string().required(),
  phone: yup
    .string()
    .required("Mobile number is required")
    .test("is-ten-digits", "Mobile number must be exactly 10 digits", (value) => {
      if (!value) return false;
      const digits = value.replace(/\D/g, "");
      const cleaned = digits.startsWith("91") ? digits.slice(2) : digits;
      return cleaned.length === 10;
    }),
});

interface AddProps {
  onClose: () => void;
  getData: () => void;
}

const AddDistributors = ({ onClose, getData }: AddProps) => {
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: { countryCode: "+91" },
    mode: "all",
  });
  const [mobile, setMobile] = React.useState("");


  const onsubmit = (data: any) => {
    // mobile already contains country code from PhoneInput
    let formattedMobile = mobile;

    // normalize once: ensure exactly one leading +
    formattedMobile = formattedMobile.startsWith("+")
      ? formattedMobile
      : `+${formattedMobile}`;
    const payload = {
      ...data,
      mobile: formattedMobile,
    };
    delete payload.countryCode;
    httpClient
      .post('distributor/create', payload)
      .then((response) => {
        console.log("Add Distributors response");
        if (response.success === true) {
          showToast("Distributor Added successfully", "success");
        } else {
          showToast(`${response.error.message}`, "error");
        }
      })
      .catch((error) => {
        console.log(error);
        showToast("Something went wrong", "error");
      })
      .finally(() => {
        console.info("closed");
        onClose();
        getData();
      });
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onsubmit)}>
        <div className="md:grid grid-cols-2 gap-6 p-2">
          <Input
            name={"distributorName"}
            label="Distributor Name"
            placeholder={"Enter Distributor Name"}
            required={true}
            alphaNumeric
            icon={<FontAwesomeIcon icon={faBuilding} className="text-gray-400" />}
          />
          <Input
            name={"customerCode"}
            label={"Distributor Code"}
            placeholder="Enter Distributor Email"
            required={true}
            icon={<FontAwesomeIcon icon={faEnvelope} className="text-gray-400" />}
          />
          <Input
            name={"email"}
            label={"Email"}
            placeholder="Enter Distributor Email"
            required={true}
            noCapitalize={true}
            icon={<FontAwesomeIcon icon={faEnvelope} className="text-gray-400" />}
          />
          <div className="mb-3">
            <label htmlFor="mobilenumber" className="block mb-1 text-sm font-medium text-gray-900 dark:text-gray-200">Contact Number <span className="text-red-500">*</span>
            </label>
            <div style={{ width: "200px" }}>
              <PhoneInput
                country="in"
                value={mobile}
                onChange={(value) => {
                  const normalized = value.startsWith("+") ? value : `+${value}`;
                  setMobile(normalized);
                  methods.setValue("phone", normalized, { shouldValidate: true })
                }}
                //In dark mode input field color
                inputClass="!w-full !bg-white  !text-[#374151]  !border-none  dark:!bg-gray-800  dark:!text-white [&>input]:!text-[#374151]
                dark:[&>input]:!text-white"
                buttonClass="!bg-white dark:!bg-gray-700"
                dropdownClass="
                !bg-white !text-[#374151] 
                dark:!bg-gray-800 dark:!text-white

                [&>.country:hover]:!bg-gray-100 
                [&>.country:hover]:!text-black
                dark:[&>.country:hover]:!bg-gray-700 
                dark:[&>.country:hover]:!text-white

                [&>.country.highlight]:!bg-gray-200 
                [&>.country.highlight]:!text-black
                dark:[&>.country.highlight]:!bg-gray-700 
                dark:[&>.country.highlight]:!text-white"//text color when cursor over the dropdown

                searchClass="!text-black dark:!text-black !bg-white dark:!bg-gray-700" //seach field text color
                enableSearch
                countryCodeEditable={false}

                containerStyle={{
                  width: "100%",
                  borderRadius: "0.5rem",
                  border: "1px solid #d1d5db",   // <- light mode border visible
                }}
                inputStyle={{ width: "100%" }}
                inputProps={{ id: "mobilenumber", name: "phone", required: true }}
              />
            </div>

            {methods.formState.errors.phone && (
              <span className="text-red-500 text-sm font-medium mt-1">
                {methods.formState.errors.phone.message as string}
              </span>
            )}
          </div>

          <Input
            name={"address"}
            label={"Address"}
            placeholder="Enter Distributor Address"
            required={true}
            icon={<FontAwesomeIcon icon={faMapMarkerAlt} className="text-gray-400" />}
          />
          <Input
            name={"contactPerson"}
            label={"Contact Person"}
            placeholder="Enter Contact Person"
            alphaNumeric
            required={true}
            icon={<FontAwesomeIcon icon={faUser} className="text-gray-400" />}
          />
        </div>
        <div className="flex flex-row items-center justify-end gap-10 mt-4">
          <PillButton type="submit" variant="secondary">
            Submit
          </PillButton>
          <PillButton type="button" variant="primary" onClick={onClose}>
            Cancel
          </PillButton>
        </div>
      </form>
    </FormProvider>
  );
};

export default AddDistributors;
